import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
/**
 * Created by user on 12/28/2016.
 */

export const GRADE_INPUT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MoneyInputComponent),
  multi: true,
};

@Component({
  selector: 'hr-money-input',
  templateUrl: './money-input.component.html',
  styleUrls: ['./money-input.component.less'],
  providers: [GRADE_INPUT_VALUE_ACCESSOR],
  standalone: false,
})
export class MoneyInputComponent implements ControlValueAccessor {
  writeValue(obj: any): void {
    this.value = obj;
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onModeTouched = fn;
  }

  @Input()
  max: number;

  @Input()
  min: number = 0;

  @Input()
  fieldKey: string;

  value: number;

  private charPattern: any = /[0-9\.]/;

  private valuePattern: any = /^([0-9]*[\.]{0,1}[0-9]{0,2})$/;

  onModelChange: Function = (val: any) => {};

  onModeTouched: Function = () => {};

  private parse(val: any) {
    if (val == null || val == undefined || val == '') {
      return null;
    }

    let newValue = val;

    if (+val < 0) {
      newValue = this.min;
    }

    if (+val > this.max) {
      newValue = this.max;
    }

    return newValue;
  }

  //TODO: replace with before input when impemente din browsers
  onKeyPress(event: any) {
    console.log('on key press');

    if (event.ctrlKey || event.altKey || event.metaKey) return;

    if (event.key.length > 1) {
      return;
    }

    let valid =
      this.charPattern.test(event.key) &&
      this.valuePattern.test(event.target.value + '' + event.key);

    if (!valid) {
      event.preventDefault();
    }
  }

  onInput(event: any, val) {
    console.log('on input');
    //this.value = val;
    //setTimeout(() => {
    let cleanValue = this.parse(val);
    console.log('model update ' + '(' + val + ')' + ' - ' + cleanValue);
    //this.value = this.parse(val);
    this.onModelChange(cleanValue);
    this.value = cleanValue;
    event.target.value = this.value;
    //this.value = cleanValue;
    //console.log('model update '+this.v);
    //}, 0);
  }

  constructor() {
    this.min = this.min || 0;
  }
}
